
import { ValidationObserver } from 'vee-validate'
import { mapGetters } from 'vuex'
import inputTextSearch from '@/components/common/form/inputTextSearch'

export default {
  components: {
    ValidationObserver,
    inputTextSearch,
  },
  data() {
    return {
      search: '',
    }
  },
  computed: {
    ...mapGetters(['showSearch']),
    searchText() {
      return this.$store.state.layoutData?.content?.general_search || {}
    },
  },
  methods: {
    close() {
      this.$store.commit('changeShowSearch', false)
      this.search = ''
    },
    async onSubmit(event) {
      if (!(await this.$refs.form.validate())) event.preventDefault()
    },
  },
}
